import { render } from "./giving-options.vue?vue&type=template&id=c79a52d6&scoped=true"
import script from "./giving-options.vue?vue&type=script&lang=js"
export * from "./giving-options.vue?vue&type=script&lang=js"

import "./giving-options.vue?vue&type=style&index=0&id=c79a52d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79a52d6"]])

export default __exports__